__turbopack_context__.v({
  "root": "InlineFilters-Wrapper-module-scss-module__FU5Kla__root",
  "scrollArea": "InlineFilters-Wrapper-module-scss-module__FU5Kla__scrollArea",
});
